import { fetchData } from '../utils/fetchData';

export const updatePaymentStatus = (billId: string, status: boolean) => {
  try {
    fetchData(`${process.env.REACT_APP_BACKEND_API}/bills/${billId}/payment`, {
      method: 'PATCH',
      body: JSON.stringify({ isPaid: status }),
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    });
  } catch (e) {
    console.error('updatePaymentStatus', e.message);
  }
};
